import { DELETE, GET, POST, POST_BLOB, PUT } from "../API";

let source;

export const createGroupCallApiCall = (
  user_ids,
  group_id,
  video,
  onSuccess,
  onError
) => {
  const data = {
    user_ids: user_ids,
    group_id: group_id,
    video: video,
  };
  POST(
    `/api/v1/chat/calls/create_with_users_and_group`,
    data,
    onSuccess,
    onError
  );
};

export const addCallParticipantAiCall = (
  user_ids,
  call_id,
  onSuccess,
  onError
) => {
  const data = {
    user_ids: user_ids,
    call_id: call_id,
  };
  POST(`/api/v1/chat/calls/add_participants_to_call`, data, onSuccess, onError);
};
export const callOfflineParticipantAiCall = (
  user_id,
  call_id,
  onSuccess,
  onError
) => {
  const data = {
    user_id: user_id,
    call_id: call_id,
  };
  POST(`/api/v1/chat/calls/ring_participant`, data, onSuccess, onError);
};

export const getCallDetailsApiCall = (uuid, onSuccess, onError) => {
  const data = {
    uuid: uuid,
  };
  POST(`/api/v1/chat/calls`, data, onSuccess, onError);
};

export const getCallsForCurrentUserApiCall = (onSuccess, onError) => {
  source = GET(`/api/v1/chat/calls`, onSuccess, onError, true, source);
};

export const deleteCallAPICall = (callId, onSuccess, onError) => {
  DELETE(
    `/api/v1/chat/calls/delete?uuid=${callId}`,
    onSuccess,
    onError,
    true,
    source
  );
};

export const transcribeAPICall = (formData, onSuccess, onError) => {
  POST(`/api/v1/chat/audio/transcribe`, formData, onSuccess, onError);
};

export const speakAudioAPICall = (text, to, onSuccess, onError, speakerUserId) => {
  const data = {
    text: text,
    to: to,
    ...(speakerUserId && { speaker_user_id: speakerUserId }),
  };
  POST_BLOB(
    `/api/v1/chat/audio/speak`,
    data,
    onSuccess,
    onError,
    true,
    null,
    true
  );
};

export const kickParticipantApiCall = (call_id, user_id, onSuccess, onError) => {
  const data = { call_id, user_id };
  POST(`/api/v1/chat/calls/kick_participant`, data, onSuccess, onError);
};

export const muteParticipantApiCall = (call_id, user_id, onSuccess, onError) => {
  const data = { call_id, user_id };
  POST(`/api/v1/chat/calls/mute_participant`, data, onSuccess, onError);
};

export const muteAllParticipantsApiCall = (call_id, onSuccess, onError) => {
  const data = { call_id };
  POST(`/api/v1/chat/calls/mute_all_participants`, data, onSuccess, onError);
};

export const updateMuteStateApiCall = (call_id, muted, onSuccess, onError) => {
  const data = { call_id, muted };
  POST(`/api/v1/chat/calls/update_mute_state`, data, onSuccess, onError);
};

export const reinviteParticipantApiCall = (call_id, user_id, onSuccess, onError) => {
  const data = { call_id, user_id };
  POST(`/api/v1/chat/calls/reinvite_participant`, data, onSuccess, onError);
};

export const makeCallAdminApiCall = (call_id, user_id, onSuccess, onError) => {
  const data = { call_id, user_id };
  POST(`/api/v1/chat/calls/make_call_admin`, data, onSuccess, onError);
};

export const revokeCallAdminApiCall = (call_id, user_id, onSuccess, onError) => {
  const data = { call_id, user_id };
  POST(`/api/v1/chat/calls/revoke_call_admin`, data, onSuccess, onError);
};

export const startRecordingApiCall = (meetingId, onSuccess, onError) => {
  POST(`/api/v1/meetings/recordings/${meetingId}/start`, {}, onSuccess, onError);
};

export const stopRecordingApiCall = (meetingId, onSuccess, onError) => {
  POST(`/api/v1/meetings/recordings/${meetingId}/stop`, {}, onSuccess, onError);
};

export const getMeetingCallSettingsApiCall = (meetingId, onSuccess, onError) => {
  GET(`/api/v1/meetings/call_settings/${meetingId}`, onSuccess, onError);
};

export const updateMeetingCallSettingsApiCall = (meetingId, settings, onSuccess, onError) => {
  PUT(`/api/v1/meetings/call_settings/${meetingId}`, settings, onSuccess, onError);
};
